import { handleResponse, handleError } from "./apiUtils";
import * as apiConfig from "./config";
const baseUrl = `${apiConfig.API_URL}user/`;
//const baseUrl = "https://localhost:44356/api/user/"; //process.env.API_URL + "/routes/";


export function getUserSummary(id) {
    var url = `${baseUrl}${id}`;
    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" }) //, "authorization": authHeader
        .then(handleResponse)
        .catch(handleError);
}

export function deleteUser(id) {
    var url = `${baseUrl}${id}`;
    return fetch(url, { method: "DELETE", headers: { "content-type": "application/json" }, credentials: "include" }) //, "authorization": authHeader
        .then(handleResponse)
        .catch(handleError);
}

export function getUserData(id, bearer) {
    var authHeader = "Bearer " + bearer; 
    return fetch(`${baseUrl}getusersettings/${id}`, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" }) //, "authorization": authHeader
        .then(handleResponse)
        .catch(handleError);
}

export function getTimelineFeed(critera) {
    return fetch(`${baseUrl}getrecentactivity`, { method: "POST", body: JSON.stringify(critera), headers: { "content-type": "application/json" }, credentials: "include" }) //, "authorization": authHeader
        .then(handleResponse)
        .catch(handleError);
}

export function getUsers(bearer) {
    var authHeader = "Bearer " + bearer; 
    return fetch(baseUrl, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" }) //, "authorization": authHeader
        .then(handleResponse)
        .catch(handleError);
}

export function updateGeneralSettings(settings) {
    return fetch(baseUrl + "updategeneralsettings", { method: "PUT", body: JSON.stringify(settings), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function updateSiteSettings(settings) {
    return fetch(baseUrl + "updatesitesettings", { method: "PUT", body: JSON.stringify(settings), headers: { "content-type": "application/json" }, credentials: "include"  })
        .then(handleResponse)
        .catch(handleError);
}

export function uploadAvatar(avatar) {
    return fetch(baseUrl + "uploadavatar", { method: "PUT", body: JSON.stringify(avatar), headers: { "content-type": "application/json" }, credentials: "include"  })
        .then(handleResponse)
        .catch(handleError);
}

export function uploadBanner(banner) {
    return fetch(baseUrl + "uploadbanner", { method: "PUT", body: JSON.stringify(banner), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function searchAllUsers(criteria) {
    return fetch(`${baseUrl}searchusernetwork`, { method: "POST", body: JSON.stringify(criteria), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getUserNotifications() {
    return fetch(`${baseUrl}notifications`, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function logUserNotificationSeen(notificationId) {
    var url = `${baseUrl}lognotificationseen/${notificationId}`
    return fetch(url, { method: "POST", body: JSON.stringify(notificationId), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}


// WEBPACK FOOTER //
// ./src/api/usersApi.js